export const COLOUR_FACET_GROUP = "SupplierColour";

export const MORE_COLOURS = "MoreColours";
export const MORE_COLOURS_FACET = "MoreColoursFacet";
export const MIX_MATCH = "MixMatch";
export const MIX_MATCH_GROUP = "MixMatchGroup";
export const MIX_MATCH_PRODUCT = "MixMatchProduct";
